const Country_List_Map: any = {
    de: [
        {
            text: 'Germany',
            textAlias: 'Deutschland',
            shortName: 'de',
            key: '1',
        },
        {
            text: 'Austria',
            textAlias: 'Österreich',
            shortName: 'au',
            key: '2',
        },
        {
            text: 'Switzerland',
            textAlias: 'Schweiz',
            shortName: 'ch',
            key: '3',
        },
        {
            text: 'Other EU countries',
            textAlias: 'Andere EU-Länder',
            shortName: 'eu',
            key: '4',
        },
    ],
    eu: [
        {
            text: 'Germany',
            shortName: 'de',
            key: '1',
        },
        {
            text: 'Austria',
            shortName: 'au',
            key: '2',
        },
        {
            text: 'Switzerland',
            shortName: 'ch',
            key: '3',
        },
        {
            text: 'Other EU countries',
            shortName: 'eu',
            key: '4',
        },
    ],
};

export const INIT_COUNTRY_MAP: any = {
    de: {
        name: 'Germany',
        id: 82,
    },
    us: {
        name: 'United States',
        id: 233,
    },
    eu: {
        name: 'Germany',
        id: 82,
    },
    uk: {
        name: 'United Kingdom',
        id: 232,
    },
    fr: {
        name: 'France',
        id: 75,
    },
    it: {
        name: 'Italy',
        id: 107,
    },
    es: {
        name: 'Spain',
        id: 207,
    },
    sa: {
        name: 'United Arab Emirates',
        id: 231,
    },
    ca: {
        name: 'Canada',
        id: 39,
    },
    br: {
        name: 'Brazil',
        id: 31,
    },
};

export const getCountryList = (locale: string, type: number) => {
    const list = Country_List_Map[locale] || Country_List_Map.eu;
    const other: any = {
        de: {
            text: 'Other countries',
            textAlias: 'Andere Länder',
            shortName: 'other',
            key: '5',
        },
        eu: {
            text: 'Other countries',
            textAlias: 'Other countries',
            shortName: 'other',
            key: '5',
        },
    };
    if (type === 2) {
        list.splice(3, 1, other[locale] || other.eu);
    }
    return list;
};

const solution_options: any[] = [
    {
        text: 'my house without any solar system',
        key: '1',
    },
    {
        text: 'my house with an existing solar system',
        key: '2',
    },
    {
        text: 'my apartment, garden or balcony',
        key: '3',
    },
    {
        text: 'my off-grid cabin, caravan or boat',
        key: '4',
    },
];

const solution_options_DE: any[] = [
    {
        aliaText: 'mein Haus ohne Solaranlage.',
        text: 'my house without any solar system',
        key: '1',
    },
    {
        aliaText: 'mein Haus mit einer bestehenden Solaranlage.',
        text: 'my house with an existing solar system',
        key: '2',
    },
    {
        aliaText: 'meine Wohnung, Garten oder Balkon.',
        text: 'my apartment, garden or balcony',
        key: '3',
    },
    {
        aliaText: 'meine netzunabhängige Hütte, mein Wohnwagen oder mein Boot.',
        text: 'my off-grid cabin, caravan or boat',
        key: '4',
    },
];

export const getSolutionList = (locale: string) => (locale === 'de' ? solution_options_DE : solution_options);

const identity_options: any[] = [
    {
        id: '1',
        text: 'Distributor',
    },
    {
        id: '2',
        text: 'Installer',
    },
    {
        id: '3',
        text: 'Electrician',
    },
    {
        id: '4',
        text: 'Homeowner',
    },
    {
        id: '5',
        text: 'Consultant',
    },
    {
        id: '6',
        text: 'Media',
    },
    {
        id: '7',
        text: 'Others',
    },
];

const identity_options_DE: any[] = [
    {
        id: '1',
        aliaText: 'Verteiler/in',
        text: 'Distributor',
    },
    {
        id: '2',
        aliaText: 'Installateur/in',
        text: 'Installer',
    },
    {
        id: '3',
        aliaText: 'Elektriker/in',
        text: 'Electrician',
    },
    {
        id: '4',
        aliaText: 'Hausbesitzer/in',
        text: 'Homeowner',
    },
    {
        id: '5',
        aliaText: 'Berater/in',
        text: 'Consultant',
    },
    {
        id: '6',
        aliaText: 'Medien',
        text: 'Media',
    },
    {
        id: '7',
        aliaText: 'Andere',
        text: 'Others',
    },
];

export const getIdentityList = (locale: string) => (locale === 'de' ? identity_options_DE : identity_options);

/**
 * @desc 正则校验
 */
export const regxName = /^.{1,30}$/;
export const regxEmail = /^[A-Za-z\d]+([.%~`$^*&(){}<>?"+=!_\\-]*[A-Za-z\d-])*@[a-zA-Z\d-]{1,30}\.[a-zA-Z\d.%#~`$^*&(){}<>?"+=!_\\-]{1,70}$/;
export const regxPhone = /^(\+)?(\d|\s|-){7,30}$/;
export const regxZip = /^[a-zA-Z0-9\s]{1,50}$/;

export const firstNameValidate = (t: any) => ({
    validator(_: any, value: string) {
        if (!value || !value.trim()) return Promise.reject(t('firstname_empty'));
        if (value && value.length > 30) return Promise.reject(t('firstname_invalid'));
        if (!value || !regxName.test(value)) return Promise.reject(t('firstname_invalid'));
        return Promise.resolve();
    },
});

export const lastNameValidate = (t: any) => ({
    validator(_: any, value: string) {
        if (!value || !value.trim()) return Promise.reject(t('lastname_empty'));
        if (value && value.length > 30) return Promise.reject(t('lastname_invalid'));
        if (!value || !regxName.test(value)) return Promise.reject(t('lastname_invalid'));
        return Promise.resolve();
    },
});

export const countryValidate = (t: any) => ({
    validator: (_: any, value: string) => {
        if (!value) return Promise.reject(t('country_empty'));
        return Promise.resolve();
    },
});

export const cityValidate = (t: any) => ({
    validator: (_: any, value: string) => {
        if (!value) return Promise.reject(t('city_empty'));
        return Promise.resolve();
    },
});

export const solutionValidate = (t: any) => ({
    validator: (_: any, value: string) => {
        if (!value) return Promise.reject(t('solution_empty'));
        return Promise.resolve();
    },
});

export const zipValidate = (t: any) => ({
    validator: (_: any, value: string) => {
        // if (!value) return Promise.reject(t('zip_empty'));
        if (value?.length > 30 || (!regxZip.test(value) && value.length > 0)) return Promise.reject(t('zip_invalid'));
        return Promise.resolve();
    },
});

export const emailValidate = (t: any) => ({
    validator: (_: any, value: string) => {
        if (!value || !value.trim()) return Promise.reject(t('email_empty'));
        if (!regxEmail.test(value) || value.length > 100) return Promise.reject(t('email_invalid'));
        return Promise.resolve();
    },
});

export const phoneValidate = (t: any) => ({
    validator(_: any, value: string) {
        if (!value || !value.trim()) return Promise.reject(t('phone_empty'));
        if (value?.length > 0 && (!regxPhone.test(value) || value.length > 30 || value.length < 7)) return Promise.reject(t('phone_invalid'));
        return Promise.resolve();
    },
});

export const companyAddressValidate = (t: any) => ({
    validator: (_: any, value: string) => {
        if (!value || !value.trim()) return Promise.reject(t('companyaddress_empty'));
        if (value.length > 300) return Promise.reject(t('companyaddress_invalid'));
        return Promise.resolve();
    },
});

export const companyNameValidate = (t: any) => ({
    validator: (_: any, value: string) => {
        if (!value || !value.trim()) return Promise.reject(t('companyname_empty'));
        if (value.length > 200) return Promise.reject(t('companyname_invalid'));
        return Promise.resolve();
    },
});

export const identityValidate = (t: any) => ({
    validator: (_: any, value: string) => {
        if (!value) return Promise.reject(t('solution_empty'));
        return Promise.resolve();
    },
});

export const billValidate = (t: any) => ({
    validator: (_: any, value: string) => {
        if (!value) return Promise.reject(t('bill_empty'));
        return Promise.resolve();
    },
});

export const areaValidate = (t: any) => ({
    validator: (_: any, value: string) => {
        if (!value) return Promise.reject(t('area_empty'));
        return Promise.resolve();
    },
});

export const HAS_INITIAL_VALUE_SOURCE = ['power-ocean'];
